<template>
  <div>
    <v-card class="mb-4">
      <v-card-text>
        <v-text-field v-model="form.name"
                      name="product_nnm"
                      label="Name"
                      placeholder="Required"
                      autocomplete="off"
                      :disabled="product?.is_external"
                      :hint="product?.is_external ? 'You cannot change the name because this product was imported from another system.' : 'This must be unique.'"
                      :persistent-hint="product?.is_external"
                      outlined
                      dense
                      :error-messages="form.errors.get('name')"
                      class="mb-4">
        </v-text-field>

        <v-text-field v-model="form.crm_name"
                      name="crm_nm"
                      label="CRM Name"
                      placeholder="CRM Name (Optional)"
                      autocomplete="off"
                      hint="Populate this if the product has a different value in CRM."
                      outlined
                      dense
                      :error-messages="form.errors.get('crm_name')"
                      class="mb-4">
        </v-text-field>

        <v-text-field v-model="form.external_id"
                      label="External ID"
                      placeholder="External ID (Optional)"
                      autocomplete="off"
                      :disabled="product?.is_external"
                      :hint="product?.is_external ? 'You cannot change the name because this product was imported from another system.' : ''"
                      :persistent-hint="product?.is_external"
                      outlined
                      dense
                      :error-messages="form.errors.get('external_id')"
                      class="mb-4">
        </v-text-field>

        <v-radio-group v-model="form.status"
                       label="Status"
                       dense>
          <v-radio value="Active"
                   label="Active">
          </v-radio>
          <v-radio value="Inactive"
                   label="Inactive">
          </v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions v-if="product"
                      class="d-flex justify-space-between">
        <div>
          <v-btn type="submit"
                 color="primary">
            Update
          </v-btn>
          <v-btn :to="{name: 'admin.products'}">
            Cancel
          </v-btn>
        </div>
        <v-btn @click.prevent="deleteProduct"
               :disabled="product.is_editable === false"
               color="error">
          Delete
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-btn type="submit"
               color="primary">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mb-4">
      <v-card-title>
        {{ form.presentations.length }} Associated {{ form.presentations.length | pluralize('Presentation', false) }}
        <v-spacer></v-spacer>
        <v-text-field v-model="search"
                      append-icon="fal fa-search"
                      label="Search"
                      outlined
                      dense
                      hide-details
                      @keydown.enter.prevent="">
        </v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table v-model="form.presentations"
                      :headers="headers"
                      :items="filteredPresentations"
                      :items-per-page="50"
                      :hide-default-footer="false"
                      :footer-props="{'items-per-page-options': [10, 25, 50, 100, -1]}"
                      :search="search"
                      dense
                      show-select>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import {orderBy} from 'lodash';
import {mapGetters} from 'vuex';
import productService from '../../../services/productService';
import DOMPurify from 'dompurify';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    ...mapGetters([
      'presentations',
    ]),
    filteredPresentations() {
      return orderBy(this.presentations, ['status'], ['asc']);
    },
    headers() {
      return [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Asset ID',
          value: 'external_id',
        },
        {
          text: 'Type',
          value: 'presentation_type',
        },
        {
          text: 'Status',
          value: 'status',
        }
      ]
    }
  },
  methods: {
    deleteProduct() {
      if (confirm('Are you sure you want to delete this product? Associated presentations will NOT be deleted.')) {
        productService.deleteProduct(this.productID)
          .then(() => {
            this.$toast.success('Product deleted.');
            setTimeout(() => {
              this.$router.replace({name: 'admin.products'});
            }, 500);
          })
          .catch(err => {
            this.$toast.error(DOMPurify.sanitize(err.message));
          })
      }
    }
  }
}
</script>
